export default "/images/vendor/flag-icon-css/flags/4x3/ki.svg?339d25434ca1eaf0ed788974b63ecd9b";